import axios from "axios";
import { getPlatformApiBaseUrl } from "../../utils/platformApiUrl";

export { getPlatformApiBaseUrl };

/**
 * Submit marketing "Get in Touch" form to `/api/v1/contact-inquiries`.
 */
export async function submitContactFormCall(data) {
  const base = getPlatformApiBaseUrl();
  if (!base) {
    return Promise.reject(
      new Error(
        "Set REACT_APP_PLATFORM_API_URL in .env before npm run build (see .env.example).",
      ),
    );
  }
  const route = `${base}/api/v1/contact-inquiries`;
  return axios.post(route, data, {
    ["axios-retry"]: {
      retries: 0,
    },
  });
}
